import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Select from 'react-select'
import PageContent from "../components/pageContent";
import { SupportQueryType } from "../components/support/constants";
import GenericSupportQuery from "../components/support/GenericSupportQuery";
import RequestForColor from "../components/support/RequestForColor";
import RequestSent from "../components/support/RequestSent";
import { addNotification } from "../redux/actions";

interface Props {
  contextLevel: string;
}

const PodporaPage = (props: Props) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Support' });
  const [requestSent, setRequestSent] = useState(false);
  const [selectedType, setSelectedType] = useState({ label: t('OptionRequiredSpecialColor'), value: 1 });

  const options = [
    { label: t('OptionRequiredSpecialColor'), value: 1 },
    { label: t('OptionQuestion'), value: 2 },
    { label: t('OptionIdeaForImprovement'), value: 3 },
    { label: t('OptionApplicationError'), value: 4 }
  ]

  const dispatch = useDispatch();

  const handleTypeChange = (val) => {

  }

  const handleRequestSent = (success, err) => {
    if (success) {
      dispatch(addNotification({ text: t('RequestHasBeenSubmitted'), type: 'success' }));
    }
    else {
      dispatch(addNotification({ text: `${t('RequestCouldNotBeSubmitted')} ${err}`, type: 'error' }));
    }
  }

  return (
    <>
      <PageContent header={t('Label')} >
        <>
          <label>
            {t('GenericText')}
          </label>
          <div className="row">
            <label className="col-sm-2 col-form-label zvlabel">
              {t('QuestionType')}
            </label>
            <div className={"col-sm-4"}>
              <Select
                isSearchable={false}
                isMulti={false}
                options={options}
                value={selectedType}
                placeholder={t('QuestionType')}
                isDisabled={false}
                onChange={(event: any) => {
                  handleTypeChange(event);
                  setSelectedType(event);
                }}
              />
            </div>
          </div>
          {!requestSent && selectedType.value === 1 &&
            <RequestForColor
              onRequestSent={
                handleRequestSent
              }
            />
          }
          {!requestSent && selectedType.value === 2 &&
            <GenericSupportQuery
              onRequestSent={
                handleRequestSent
              }
              queryType={SupportQueryType.question}
            />
          }
          {!requestSent && selectedType.value === 3 &&
            <GenericSupportQuery
              onRequestSent={
                handleRequestSent
              }
              queryType={SupportQueryType.improvement}
            />
          }
          {!requestSent && selectedType.value === 4 &&
            <GenericSupportQuery
              onRequestSent={
                handleRequestSent
              }
              queryType={SupportQueryType.errorReport}
            />
          }
          {requestSent && <RequestSent />}
        </>
      </PageContent>
    </>
  );
};

export default PodporaPage;
